import { mat2d, vec2, glMatrix } from "gl-matrix";

glMatrix.setMatrixArrayType(Array);
class Rectangle {
  constructor(/**Object **/ tl, /**Object **/ tr, /**Object **/ bl, /**Object **/ br) {
    this.tl = vec2.fromValues(tl.x, tl.y);
    this.tr = vec2.fromValues(tr.x, tr.y);
    this.bl = vec2.fromValues(bl.x, bl.y);
    this.br = vec2.fromValues(br.x, br.y);

    this.w = Math.abs(this.tr[0] - this.tl[0]);
    this.h = Math.abs(this.br[1] - this.tr[1]);
  }

  rotate(angle) {
    if (angle != 0) {
      let radians = (Math.PI / 180) * angle;
      let origin = vec2.fromValues(this.tl[0] + this.w / 2, this.tl[1] + this.h / 2);

      let transMatrix = mat2d.create();
      mat2d.translate(transMatrix, transMatrix, origin);
      mat2d.rotate(transMatrix, transMatrix, radians);
      mat2d.translate(transMatrix, transMatrix, vec2.negate(origin, origin));

      vec2.transformMat2d(this.tl, this.tl, transMatrix);
      vec2.transformMat2d(this.tr, this.tr, transMatrix);
      vec2.transformMat2d(this.bl, this.bl, transMatrix);
      vec2.transformMat2d(this.br, this.br, transMatrix);

      this.tl[0] = Math.round(this.tl[0]);
      this.tl[1] = Math.round(this.tl[1]);

      this.tr[0] = Math.round(this.tr[0]);
      this.tr[1] = Math.round(this.tr[1]);

      this.bl[0] = Math.round(this.bl[0]);
      this.bl[1] = Math.round(this.bl[1]);

      this.br[0] = Math.round(this.br[0]);
      this.br[1] = Math.round(this.br[1]);
    }
  }
}

export default Rectangle;
